import React, { ReactNode } from "react";

import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import { isDefined } from "@mapmycustomers/shared/util/assert";

import localSettings from "@app/config/LocalSettings";

import styles from "./Count.module.scss";

interface Props {
  className?: string;
  count?: number;
  currency?: boolean;
  suffix?: ReactNode;
  valueFormatter?: (value: number) => string;
}

const Count: React.FC<Props> = ({ className, count, currency, suffix, valueFormatter }) => {
  const intl = useIntl();

  if (!isDefined(count)) {
    return null;
  }

  const formattedNumber = intl.formatNumber(
    count,
    currency
      ? {
          currency: localSettings.getCurrencyCode(),
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
          notation: count >= 10000 ? "compact" : "standard",
          style: "currency",
        }
      : {
          maximumFractionDigits: 2,
          notation: count >= 10000 ? "compact" : "standard",
        }
  );

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.content}>
        <Tooltip
          overlayClassName={styles.tooltip}
          placement="bottom"
          title={valueFormatter ? valueFormatter(count) : formattedNumber}
        >
          {valueFormatter ? valueFormatter(count) : formattedNumber}
        </Tooltip>
        {suffix}
      </div>
    </div>
  );
};

export default Count;
